import Vue from 'vue'
import { Input } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'

Vue.use(Input)

export default Vue.extend({
  template: `
    <a-tooltip placement="right" title="Row is locked click here to unlock" :title="params.type === 'dynamicTable' ? title : null" v-if="!params.viewOnly && !params.isArchive">
      <div style="pointer-events: unset!important" class="a-gcell">
        <a-tooltip placement="right" title="Row is locked click here to unlock" v-if="value">
          <a @click='() => saveData()' :disabled="params.type === 'dynamicTable'" v-if="value">
            <i class='fa fa-lock mr-2 mt-1' aria-hidden='true' style='color: #71283e;font-size: 20px'/>
          </a>
        </a-tooltip>
      </div>
    </a-tooltip>
    <a-tooltip placement="right" title="You can not unlock the record" v-else-if="value && (params.viewOnly || params.isArchive)">
      <i class='fa fa-lock mr-2 mt-1' aria-hidden='true' style='color: #71283e;font-size: 20px; cursor: not-allowed;' disabled/>
    </a-tooltip>
    `,

  data() {
    return {
      value: null,
      loading: false,
      savePreviousData: savePreviousData,
      title:
        'Takeoff is locked due to some updates on analysis sheet. Please unlock it from the analysis sheet to update the takeoff',
    }
  },
  created() {
    this.value = this.params.value
  },
  methods: {
    saveData(value) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to unlock this row ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will effect values and calculations of this row</p>{' '}
            Please confirm.
          </div>
        ),
        onOk() {
          that.value = that.value === 0 ? 1 : 0
          switch (that.params.colDef['cellRendererParams'].type) {
            case 'analysisSheet':
              that.$root.$emit(
                'saveAnalysisData',
                that.value,
                that.params.data,
                that.params.colDef.field,
                that.params.data.columnId,
                that.params.colDef['cellRendererParams'].dataType,
              )
              break
            case 'AnalysisSheet':
              that.$root.$emit('unlockRow', that.params.data)
              break
          }
        },
        onCancel() {},
      })
    },
    getValue() {
      return this.value
    },
  },
})
